import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import router from './router/router.tsx';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './locale/translations.ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/context/AuthContext.tsx';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
// import * as Sentry from '@sentry/react';
import { Theme } from 'react-daisyui';
import '@fontsource-variable/inter';
import './index.css';
import { SearchProvider } from '@/context/SearchContext.tsx';

dayjs.extend(utc);

i18n.use(initReactI18next).init({
  resources: translations,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export const queryClient = new QueryClient();
//
// Sentry.init({
//   dsn: import.meta.env.VITE_SENTRY_DSN,
//   integrations: [
//     Sentry.captureConsoleIntegration({
//       levels: ['error'],
//     }),
//   ],
// });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Theme dataTheme="light">
          <SearchProvider>
            <RouterProvider router={router} />
          </SearchProvider>
        </Theme>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
